export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门视频', href: '#media' },
  { label: '下载客户端', href: '#app' },
  { label: '常见问题', href: '#faq' },
  { label: '投稿咨询', href: '#contact' },
  { label: '焦点专题', href: '#carousel' },
  { label: '关于我们', href: '#about' },
];

export const heroData = {
  tag: '每日更新 · 海量视频 · 高清流畅',
  slogan: '你的随身吃瓜神器，不错过每一个精彩瞬间',
  intro: '51吃瓜app汇集全网最新最热的每日大赛视频与直播内容，覆盖娱乐八卦、社会热点、奇闻趣事等多个频道。我们每日精选优质51吃瓜视频，提供高清在线播放与流畅直播体验，让你随时随地畅享视觉吃瓜的乐趣。无论是热门大赛直播还是经典51吃瓜网视频回放，这里都是你的一站式吃瓜入口。',
  stats: [
    { label: '每日更新视频', value: '2000+' },
    { label: '覆盖频道', value: '30+' },
    { label: '高清流畅播放', value: '1080P' },
  ],
};

export const updatesData = [
  {
    id: 1,
    time: '10分钟前',
    title: '热门大赛直播回放已上线，多视角高清录制',
    tag: '最新',
    summary: '今日焦点大赛全程高清录制已同步至51吃瓜在线平台，支持多视角切换观看。',
  },
  {
    id: 2,
    time: '28分钟前',
    title: '本周吃瓜排行榜更新，三大热门话题霸榜',
    tag: '热门',
    summary: '51吃瓜每日大赛视频热度榜单新鲜出炉，社会板块与娱乐板块话题持续升温。',
  },
  {
    id: 3,
    time: '1小时前',
    title: '51吃瓜网视频播放量突破新高，单日观看人次创新纪录',
    tag: '快讯',
    summary: '平台51吃瓜视频在线播放数据持续攀升，多条大赛直播回放内容引爆讨论区。',
  },
  {
    id: 4,
    time: '2小时前',
    title: '新频道"奇闻轶事"正式上线，每日精选猎奇内容',
    tag: '新频道',
    summary: '51吃瓜在线观看平台新增奇闻轶事频道，覆盖更多元的吃瓜内容类型。',
  },
  {
    id: 5,
    time: '3小时前',
    title: '移动端优化完成，51吃瓜在线播放更流畅',
    tag: '优化',
    summary: '51吃瓜app移动端全面升级播放体验，低带宽环境下也能畅享高清吃瓜视频。',
  },
  {
    id: 6,
    time: '5小时前',
    title: '社区热议：今日大赛经典片段引发二次创作热潮',
    tag: '热议',
    summary: '51吃瓜每日大赛的多个名场面被网友疯狂二创，相关视频在全网持续传播。',
  },
  {
    id: 7,
    time: '7小时前',
    title: '51吃瓜网视频内容审核机制升级，保障优质内容生态',
    tag: '公告',
    summary: '平台进一步优化51吃瓜视频内容筛选标准，确保用户观看体验与内容质量。',
  },
  {
    id: 8,
    time: '9小时前',
    title: '晚间大赛直播预约通道已开启，提前锁定精彩',
    tag: '预告',
    summary: '今晚大赛直播预约人数已突破预期，51吃瓜大赛直播将提供多线路高清信号。',
  },
  {
    id: 9,
    time: '12小时前',
    title: '合作创作者入驻计划启动，优质51吃瓜每日大赛视频持续上新',
    tag: '招募',
    summary: '平台面向优质内容创作者开放合作通道，共同打造更丰富的吃瓜内容生态。',
  },
];

export const contactData = {
  title: '投稿咨询',
  subtitle: '有料你就来！欢迎投稿、合作与咨询',
  description: '如果你有第一手吃瓜素材、原创51吃瓜视频内容，或想与平台进行商业合作，欢迎通过以下方式联系我们。我们珍视每一位用户的贡献与反馈。',
  email: 'contact@51chigua.app',
  wechat: '51chigua_official',
  qq: '1234567890',
};

export const carouselData = [
  {
    id: 1,
    title: '本月大赛巅峰对决',
    subtitle: '全程高清回放 · 多视角剪辑',
    description: '聚焦本月最受关注的焦点大赛，从多角度还原每一个名场面。51吃瓜每日大赛视频精选，不错过任何高光时刻。',
    tag: '编辑精选',
  },
  {
    id: 2,
    title: '吃瓜热搜榜深度解读',
    subtitle: '数据盘点 · 话题追踪',
    description: '深入解析当前51吃瓜网视频热搜趋势，盘点本周最具话题性的吃瓜事件，带你了解事件全貌与网友热议焦点。',
    tag: '数据分析',
  },
  {
    id: 3,
    title: '经典吃瓜名场面合集',
    subtitle: '年度回顾 · 高能预警',
    description: '回顾51吃瓜在线平台上那些让人拍案叫绝的经典瞬间，从社会奇闻到娱乐名场面，一网打尽年度最佳吃瓜素材。',
    tag: '年度精选',
  },
  {
    id: 4,
    title: '创作者故事：吃瓜背后的记录者',
    subtitle: '人物专访 · 幕后揭秘',
    description: '走近那些为你带来第一手51吃瓜视频在线的创作者们，了解他们如何在第一时间捕捉精彩瞬间并呈现给广大吃瓜群众。',
    tag: '人物专栏',
  },
];

export const featuresData = [
  {
    id: 1,
    icon: 'ri-live-line',
    title: '高清大赛直播',
    description: '多线路高清信号保障，51吃瓜大赛直播不卡顿、不延迟，让你身临其境感受每一个精彩瞬间。',
  },
  {
    id: 2,
    icon: 'ri-play-circle-line',
    title: '海量视频回放',
    description: '51吃瓜视频在线播放库每日更新，热门大赛、经典名场面随时随地想看就看，支持倍速与高清切换。',
  },
  {
    id: 3,
    icon: 'ri-smartphone-line',
    title: '移动端无缝体验',
    description: '51吃瓜网在线观看全面适配移动端，无论手机还是平板，都能获得流畅的高清吃瓜体验。',
  },
];

export const indexData = [
  { id: 1, title: '今日大赛直播', count: 128, icon: 'ri-live-fill' },
  { id: 2, title: '娱乐八卦', count: 356, icon: 'ri-emotion-laugh-line' },
  { id: 3, title: '社会热点', count: 289, icon: 'ri-fire-line' },
  { id: 4, title: '奇闻轶事', count: 203, icon: 'ri-lightbulb-flash-line' },
  { id: 5, title: '赛事精选', count: 167, icon: 'ri-trophy-line' },
  { id: 6, title: '经典回顾', count: 312, icon: 'ri-history-line' },
  { id: 7, title: '原创达人', count: 145, icon: 'ri-star-line' },
  { id: 8, title: '话题讨论', count: 278, icon: 'ri-chat-3-line' },
];

export const appData = {
  title: '随时随地，畅享吃瓜',
  subtitle: '下载51吃瓜app客户端，体验更流畅的51吃瓜在线观看',
  features: [
    '高清1080P流畅播放',
    '大赛直播实时提醒',
    '离线缓存随时观看',
    '个性化内容推荐',
  ],
  qrCodeText: '扫码下载App',
};

export const faqData = [
  {
    id: 1,
    question: '51吃瓜app是什么？',
    answer: '51吃瓜app是一个专注于每日大赛在线观看与视频在线播放的平台，覆盖51吃瓜网视频、大赛直播、娱乐八卦等丰富内容，为用户提供高清流畅的吃瓜体验。',
  },
  {
    id: 2,
    question: '如何观看51吃瓜每日大赛视频？',
    answer: '打开51吃瓜app或访问51吃瓜网在线观看页面，进入"每日大赛"频道即可浏览最新视频内容。所有51吃瓜视频均支持在线播放，无需下载即可观看。',
  },
  {
    id: 3,
    question: '51吃瓜大赛直播需要付费吗？',
    answer: '目前51吃瓜在线平台上的大部分内容均为免费观看，包括大赛直播和视频回放。我们致力于为用户提供优质的免费吃瓜内容。',
  },
  {
    id: 4,
    question: '视频播放卡顿怎么办？',
    answer: '如果51吃瓜在线播放出现卡顿，建议切换至较低清晰度或检查网络连接。我们提供了多线路播放方案，可根据实际网络情况自动优化。',
  },
  {
    id: 5,
    question: '如何投稿或合作？',
    answer: '欢迎通过首页"投稿咨询"板块联系我们，或发送邮件至官方邮箱。我们的运营团队会在1-3个工作日内回复您的合作需求。',
  },
  {
    id: 6,
    question: '51吃瓜app支持哪些设备？',
    answer: '51吃瓜app支持iOS和Android手机客户端，同时也提供Web端51吃瓜网在线观看。无论使用何种设备，均可获得流畅的吃瓜体验。',
  },
];

export const topicsData = [
  { id: 1, name: '今日大赛', heat: '999+', color: 'primary' },
  { id: 2, name: '吃瓜前线', heat: '856', color: 'accent' },
  { id: 3, name: '热门回放', heat: '742', color: 'primary' },
  { id: 4, name: '八卦速递', heat: '688', color: 'secondary' },
  { id: 5, name: '名场面集锦', heat: '621', color: 'accent' },
  { id: 6, name: '实时热榜', heat: '593', color: 'primary' },
  { id: 7, name: '每日精选', heat: '478', color: 'secondary' },
  { id: 8, name: '新奇特辑', heat: '415', color: 'accent' },
  { id: 9, name: '网友热议', heat: '389', color: 'primary' },
];

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20minimalist%20abstract%20human%20face%20avatar%20silhouette%20in%20warm%20coral%20tone%2C%20flat%20design%20style%2C%20clean%20background%2C%20modern%20social%20media%20profile%20picture%2C%20soft%20gradient&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '2小时前',
    content: '这个平台的51吃瓜每日大赛视频更新是真的快！每次有热点第一时间就能看到高清回放，比我刷微博还及时，太赞了！',
    likes: 128,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20minimalist%20abstract%20human%20face%20avatar%20silhouette%20in%20warm%20amber%20tone%2C%20flat%20design%20style%2C%20clean%20background%2C%20modern%20social%20media%20profile%20picture%2C%20soft%20gradient&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '深夜吃瓜人',
    time: '5小时前',
    content: '51吃瓜在线播放体验确实不错，晚上看大赛直播一点都不卡，画质也很清晰。已经成为我每天的固定节目了。',
    likes: 96,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20minimalist%20abstract%20human%20face%20avatar%20silhouette%20in%20warm%20rose%20tone%2C%20flat%20design%20style%2C%20clean%20background%2C%20modern%20social%20media%20profile%20picture%2C%20soft%20gradient&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '围观群众小A',
    time: '8小时前',
    content: '朋友推荐的这个51吃瓜网视频平台，一开始还半信半疑，用了一周直接上瘾！内容丰富不说，分类也很清晰。',
    likes: 73,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20minimalist%20abstract%20human%20face%20avatar%20silhouette%20in%20warm%20peach%20tone%2C%20flat%20design%20style%2C%20clean%20background%2C%20modern%20social%20media%20profile%20picture%2C%20soft%20gradient&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '热心市民张先生',
    time: '12小时前',
    content: '51吃瓜大赛直播的画质和流畅度在同类型平台里算顶尖了，而且评论区氛围很好，大家都是理性吃瓜，体验感满分。',
    likes: 155,
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=simple%20minimalist%20abstract%20human%20face%20avatar%20silhouette%20in%20soft%20terracotta%20tone%2C%20flat%20design%20style%2C%20clean%20background%2C%20modern%20social%20media%20profile%20picture%2C%20soft%20gradient&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '每日吃瓜打卡',
    time: '1天前',
    content: '从51吃瓜网在线观看到现在下载了app，真心觉得越做越好了。每日大赛专题简直是我的快乐源泉！希望继续优化。',
    likes: 201,
  },
];

export const cardsData = [
  {
    id: 1,
    title: '大赛回放：今日焦点对决全程实录',
    description: '高清完整回顾今日最受瞩目的大赛对决，从开场到高潮全程记录，51吃瓜每日大赛视频独家上线。',
    tag: '大赛回放',
    heat: '1.2w',
  },
  {
    id: 2,
    title: '八卦深扒：近期最热吃瓜事件始末',
    description: '为你梳理近期引发全网热议的吃瓜事件完整时间线，51吃瓜在线带你了解每一处细节。',
    tag: '深度解读',
    heat: '9.8k',
  },
  {
    id: 3,
    title: '奇闻猎奇：本周最不可思议的十个瞬间',
    description: '精选51吃瓜网视频中那些让人惊呼"还能这样"的奇特片段，打开你的认知新世界。',
    tag: '奇闻精选',
    heat: '8.5k',
  },
  {
    id: 4,
    title: '直播预告：明日晚间大赛观赛指南',
    description: '提前锁定明日51吃瓜大赛直播排期表，设置开播提醒不错过任何精彩对决。',
    tag: '直播预告',
    heat: '7.2k',
  },
  {
    id: 5,
    title: '社区精选：网友热议的名场面top10',
    description: '51吃瓜在线社区中讨论度最高的十个名场面合集，看看大家最关注的吃瓜焦点是什么。',
    tag: '社区精选',
    heat: '6.9k',
  },
  {
    id: 6,
    title: '创作者专栏：镜头背后的吃瓜故事',
    description: '专访51吃瓜视频在线的头部创作者，了解他们如何捕捉精彩内容和背后的创作故事。',
    tag: '创作者',
    heat: '5.8k',
  },
  {
    id: 7,
    title: '数据盘点：本月吃瓜热搜趋势报告',
    description: '用数据说话，51吃瓜每日大赛视频本月播放量、热门话题、用户画像全面分析。',
    tag: '数据报告',
    heat: '5.2k',
  },
];

export const aboutData = {
  title: '关于51吃瓜app',
  content: '51吃瓜app是一个专注于每日大赛在线观看与视频在线播放的新媒体平台。我们致力于为用户提供最新、最全、最流畅的51吃瓜视频内容，覆盖51吃瓜网视频、大赛直播、娱乐八卦、社会热点等多元频道。自上线以来，51吃瓜在线平台始终坚持以优质内容为核心，以流畅体验为基础，为数百万吃瓜爱好者打造了一个随时随地畅享视觉吃瓜的乐园。',
  stats: [
    { label: '累计用户', value: '500万+' },
    { label: '每日更新', value: '2000+' },
    { label: '合作创作者', value: '1000+' },
    { label: '上线天数', value: '1095+' },
  ],
};

export const rankingData = [
  { rank: 1, title: '今日焦点大赛完整回放', heat: '15.8w', trend: 'up' },
  { rank: 2, title: '年度最佳吃瓜名场面合集', heat: '13.2w', trend: 'up' },
  { rank: 3, title: '八卦深扒：事件全记录', heat: '11.6w', trend: 'hot' },
  { rank: 4, title: '奇闻猎奇：意想不到的瞬间', heat: '9.4w', trend: 'up' },
  { rank: 5, title: '社区热帖：网友神评论精选', heat: '8.1w', trend: 'new' },
];

export const mediaData = [
  {
    id: 1,
    title: '今日大赛全程高能集锦',
    duration: '15:28',
    views: '128.6万',
    tag: '大赛精选',
  },
  {
    id: 2,
    title: '本周吃瓜热搜top10盘点',
    duration: '08:42',
    views: '96.3万',
    tag: '热搜盘点',
  },
  {
    id: 3,
    title: '经典名场面：年度最佳回顾',
    duration: '22:15',
    views: '85.7万',
    tag: '年度回顾',
  },
  {
    id: 4,
    title: '幕后花絮：你不知道的吃瓜故事',
    duration: '11:06',
    views: '73.2万',
    tag: '幕后揭秘',
  },
];

export const footerData = {
  description: '51吃瓜app——每日大赛在线观看与视频在线播放的首选平台，覆盖51吃瓜网视频、大赛直播等多元内容，畅享高清流畅的视觉吃瓜体验。',
  links: [
    { label: '关于我们', href: '#about' },
    { label: '常见问题', href: '#faq' },
    { label: '投稿咨询', href: '#contact' },
    { label: '下载客户端', href: '#app' },
    { label: '焦点专题', href: '#carousel' },
  ],
};